import React, { useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../stores";

function GalleryModal({ image, setImage, search, setSearch }: any) {
  const { galleryList } = useSelector((state: RootState) => state.gallery);
  const [modal, setModal] = useState<any>(false);

  const [loading, setLoading] = useState(false);

  const handleSelect = (value: any) => {
    const data = [...image];

    const findIndex = data.findIndex((d) => d.id === value.id);
    if (findIndex > -1) {
      data.splice(findIndex, 1);
    } else {
      data.push(value);
    }
    setImage(data);
  };

  return (
    <div>
      <div className="modal" style={{ display: modal ? "block" : "none" }}>
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content">
            <div className="modal-header border-bottom-0">
              <div className={"row"} style={{ width: "100%" }}>
                <div className={"col-md-9"}>
                  <h6 className="modal-title">AMSME Trading Photos</h6>
                </div>
                <div className={"col-md-3"}>
                  <input
                    type="text"
                    placeholder="Search..."
                    value={search}
                    className={"form-control form-control-sm"}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>
              </div>
              <button
                type="button"
                className="btn-close"
                onClick={() => setModal(false)}
              />
            </div>
            <div className="modal-body">
              <div className="form-validation">
                <div className="row mb-3">
                  {galleryList.map((gallery: any, index: number) => {
                    return (
                      <div className={"col-md-2"} key={index}>
                        <div
                          className={"border imageCard"}
                          onClick={() => handleSelect(gallery)}
                        >
                          <img
                            src={gallery.image}
                            alt={gallery.name}
                            className={"img-fluid p-2 card-img"}
                            style={{
                              objectFit: "contain",
                            }}
                          />
                          {image.some((item: any) => item.id === gallery.id) ? (
                            <div className="overlay">
                              <span className="selected-sign">
                                <i className={"fa fa-check-circle fa-2x"}></i>
                              </span>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-danger light"
                data-bs-dismiss="modal"
                disabled={loading}
                onClick={() => setModal(false)}
              >
                Close
              </button>
              <button
                type={"button"}
                className="btn btn-primary px-4"
                onClick={() => setModal(false)}
              >
                Add Photos
              </button>
            </div>
          </div>
        </div>
      </div>
      <a href={"javascript:void(0)"} onClick={() => setModal(true)}>
        AMSME Store Photos
      </a>
    </div>
  );
}

export default GalleryModal;
